import React from 'react';
import { KnowledgeModule } from '../../types';
import { Pill, btn, btnTone, td, trClick } from '../../components/Kit';

/** One knowledge module as a table row — click to edit, delete on the right. */
const ModuleRow: React.FC<{
  module: KnowledgeModule;
  onEdit: (module: KnowledgeModule) => void;
  onDelete: (id: string) => void;
}> = ({ module, onEdit, onDelete }) => {
  const mediaType = module.content?.media?.type || 'text';
  const description = module.content?.description || '';
  const tone = mediaType === 'video' ? 'gold' : mediaType === 'image' || mediaType === 'carousel' ? 'info' : undefined;

  return (
    <tr onClick={() => onEdit(module)} className={trClick()}>
      <td className={`${td} text-right text-graphite w-12`}>{module.display_order}</td>
      <td className={`${td} whitespace-normal`}>
        <div className="font-semibold text-charcoal">{module.title}</div>
        <div className="text-[12px] text-graphite font-mono">{module.module_id}</div>
      </td>
      <td className={td}><Pill tone={tone}>{mediaType}</Pill></td>
      <td className={`${td} whitespace-normal text-[12.5px] text-graphite max-w-[520px]`}>
        <span className="line-clamp-2">{description}</span>
      </td>
      <td className={`${td} text-right`}>
        <button type="button" title="Delete"
                onClick={(e) => { e.stopPropagation(); onDelete(module.id); }}
                className={`${btn} ${btnTone.ghost} hover:text-brick`}>Delete</button>
      </td>
    </tr>
  );
};

export default ModuleRow;
